import { render, staticRenderFns } from "./VideoConfiguration.vue?vue&type=template&id=2a09033c&scoped=true"
import script from "./VideoConfiguration.vue?vue&type=script&lang=js"
export * from "./VideoConfiguration.vue?vue&type=script&lang=js"
import style0 from "./VideoConfiguration.vue?vue&type=style&index=0&id=2a09033c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a09033c",
  null
  
)

export default component.exports